import {
    FETCH_RANK_DELTA_START,
    FETCH_RANK_DELTA_SUCCESS,
    FETCH_RANK_DELTA_FAIL,

} from "../../../constants";
import {
    FETCH_RANK_DELTA_URL,
} from "../../../../../config/constants";
import { createVisualizationFetchAction } from "./createVisualizationFetchAction";

export const getRankDelta = createVisualizationFetchAction(FETCH_RANK_DELTA_URL, {
    START: FETCH_RANK_DELTA_START,
    SUCCESS: FETCH_RANK_DELTA_SUCCESS,
    FAIL: FETCH_RANK_DELTA_FAIL,
});
